import { createAction, props } from '@ngrx/store';
import { Cart } from '@shared/models/cart';

export const loadCart = createAction('[Cart] Load Cart', props<{ id: string }>());

export const loadCartSuccess = createAction('[Cart] Load Cart Success', props<{ cart: Cart }>());

export const loadCartFailure = createAction('[Cart] Load Cart Failure', props<{ error: any }>());
